import * as angular from 'angular';

import { AugmentedLog, ComponentDefinition } from '../../../models';
import { StackedLogs } from './StackedLogs.chart';

class StackedLogsController implements angular.IComponentController {
    isLoading: boolean;
    logs: AugmentedLog[];
    private _chart: StackedLogs;
    static $inject = ['$element'];

    constructor(private _$element: any) {
    }

    $onInit() {
        this._chart = new StackedLogs(this._$element.children('.widget-content')[0]);
        // .size({ width: 800, height: 600 });
        this._$element
            .resize(() => {
                const w = this._$element.width();
                const h = this._$element.height();
                this._chart.size({ width: w, height: h });
            });
        if (this.logs) {
            this._chart
                .update(this.logs);
        }
    }

    $onChanges(changesObj) {
        if (changesObj['logs'] && this._chart) {
            this._chart.update(changesObj['logs'].currentValue);
        }
    }
}

export const wtStackedLogs: ComponentDefinition = {
    componentId: 'wtStackedLogs',
    controller: StackedLogsController,
    template: require('./StackedLogs.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<',
        isLoading: '<'
    }
};
